import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d39bbd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex align-start ga-3 px-4 pt-3"
}
const _hoisted_2 = {
  key: 0,
  class: "contexto flex-grow-1 min-w-0 text-caption text-medium-emphasis"
}
const _hoisted_3 = {
  key: 1,
  class: "text-caption text-medium-emphasis text-no-wrap ml-auto"
}
const _hoisted_4 = { class: "px-4 py-2" }
const _hoisted_5 = { class: "flex-grow-1 min-w-0" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 3,
  class: "d-block text-caption text-medium-emphasis text-truncate"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 3,
  class: "d-block text-caption text-medium-emphasis text-truncate"
}
const _hoisted_10 = { class: "d-flex align-center ga-2 px-4 py-2 text-caption text-medium-emphasis" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "·", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "·", -1))
const _hoisted_13 = { class: "flex-grow-1 min-w-0 text-truncate" }
const _hoisted_14 = {
  key: 2,
  class: "text-no-wrap ml-auto"
}
const _hoisted_15 = { class: "px-4 py-2" }

import { computed } from "vue";

export interface JugadorPartidaLectura {
  idUsuario: number;
  nick?: string;
  ejercito?: string | null;
  puntos?: number | null;
  // Solo en Parejas: compañero del jugador, en su mismo lado
  companero?: JugadorPartidaLectura | null;
}

//eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'CardPartidaLectura',
  props: {
    jugador1: {},
    jugador2: {},
    contexto: {},
    fecha: {},
    escenario: {},
    puntosPartida: {},
    idGanador: {},
    idUsuarioDestacado: {},
    listasVisibles: { type: Boolean },
    eloVariacion: {}
  },
  emits: ["verLista"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

//eslint-disable-next-line no-undef
const emit = __emit;

// En Parejas el destacado puede ser el compañero: cuenta su lado entero
const esDelLado = (jugador: JugadorPartidaLectura) =>
  props.idUsuarioDestacado !== undefined &&
  (jugador.idUsuario === props.idUsuarioDestacado ||
    jugador.companero?.idUsuario === props.idUsuarioDestacado);

const jugadores = computed(() => {
  const lista = [props.jugador1, props.jugador2];
  return esDelLado(props.jugador2) ? lista.reverse() : lista;
});

// El ganador de la partida es el jugador de cada lado, no el compañero
const idLadoDestacado = computed(() => {
  if (esDelLado(props.jugador2)) return props.jugador2.idUsuario;
  if (esDelLado(props.jugador1)) return props.jugador1.idUsuario;
  return props.idUsuarioDestacado;
});

const esGanador = (jugador: JugadorPartidaLectura) =>
  !!props.idGanador && props.idGanador === jugador.idUsuario;

const ejercito = (nombre?: string | null) =>
  nombre && nombre !== "N/A" ? nombre : "";

// Colores del tema como texto: se leen bien sobre fondo oscuro
const resultado = computed(() => {
  if (!props.idGanador) return { etiqueta: "Empate", color: "warning" };
  return props.idGanador === idLadoDestacado.value
    ? { etiqueta: "Victoria", color: "success" }
    : { etiqueta: "Derrota", color: "error" };
});

const colorElo = computed(() => {
  if (!props.eloVariacion) return "medium-emphasis";
  return props.eloVariacion > 0 ? "success" : "error";
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    variant: "flat",
    border: "",
    class: "text-left"
  }, {
    default: _withCtx(() => [
      (_ctx.contexto || _ctx.fecha)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.contexto)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.contexto), 1))
              : _createCommentVNode("", true),
            (_ctx.fecha)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.fecha), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jugadores.value, (jugador) => {
          return (_openBlock(), _createElementBlock("div", {
            key: jugador.idUsuario,
            class: "d-flex align-center ga-2 py-1"
          }, [
            _createElementVNode("div", _hoisted_5, [
              (jugador.idUsuario !== _ctx.idUsuarioDestacado)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {
              name: 'detalle-jugador',
              params: { idUsuario: jugador.idUsuario },
            },
                    class: _normalizeClass([
              'nick-enlace d-block text-truncate',
              esGanador(jugador) ? 'font-weight-bold' : 'text-medium-emphasis',
            ])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(jugador.nick), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass([
              'd-block text-truncate',
              esGanador(jugador) ? 'font-weight-bold' : 'text-medium-emphasis',
            ])
                  }, _toDisplayString(jugador.nick), 3)),
              (ejercito(jugador.ejercito) && _ctx.listasVisibles)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "ejercito-enlace d-block text-caption text-medium-emphasis text-truncate mw-100",
                    onClick: ($event: any) => (emit('verLista', jugador))
                  }, _toDisplayString(ejercito(jugador.ejercito)), 9, _hoisted_6))
                : (ejercito(jugador.ejercito))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(ejercito(jugador.ejercito)), 1))
                  : _createCommentVNode("", true),
              (jugador.companero)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    (jugador.companero.idUsuario !== _ctx.idUsuarioDestacado)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: {
                name: 'detalle-jugador',
                params: { idUsuario: jugador.companero.idUsuario },
              },
                          class: _normalizeClass([
                'nick-enlace d-block text-truncate',
                esGanador(jugador) ? 'font-weight-bold' : 'text-medium-emphasis',
              ])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(jugador.companero.nick), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "class"]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass([
                'd-block text-truncate',
                esGanador(jugador) ? 'font-weight-bold' : 'text-medium-emphasis',
              ])
                        }, _toDisplayString(jugador.companero.nick), 3)),
                    (ejercito(jugador.companero.ejercito) && _ctx.listasVisibles)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          class: "ejercito-enlace d-block text-caption text-medium-emphasis text-truncate mw-100",
                          onClick: ($event: any) => (emit('verLista', jugador.companero))
                        }, _toDisplayString(ejercito(jugador.companero.ejercito)), 9, _hoisted_8))
                      : (ejercito(jugador.companero.ejercito))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(ejercito(jugador.companero.ejercito)), 1))
                        : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass([
            'marcador-lectura text-h6',
            esGanador(jugador) ? 'font-weight-bold' : 'text-medium-emphasis',
          ])
            }, _toDisplayString(jugador.puntos ?? "-"), 3),
            _createVNode(_component_v_icon, {
              size: "small",
              class: _normalizeClass(['ganador-icono', { invisible: !esGanador(jugador) }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(" mdi-menu-left ")
              ]),
              _: 2
            }, 1032, ["class"])
          ]))
        }), 128))
      ]),
      _createVNode(_component_v_divider),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", {
          class: _normalizeClass(['font-weight-bold text-no-wrap', `text-${resultado.value.color}`])
        }, _toDisplayString(resultado.value.etiqueta), 3),
        (_ctx.eloVariacion != null)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_11,
              _createElementVNode("span", {
                class: _normalizeClass(['font-weight-bold text-no-wrap', `text-${colorElo.value}`])
              }, _toDisplayString(_ctx.eloVariacion > 0 ? "+" : "") + _toDisplayString(_ctx.eloVariacion) + " ELO ", 3)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.escenario)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.escenario), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.puntosPartida)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.puntosPartida) + " pts ", 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_15, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})